import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function UserOnlyRoute() {
  const { user, loading } = useAuth();

  if (loading) return null;

  const isAdmin = String(user?.role || "").toLowerCase() === "admin";
  if (isAdmin) {
    return <Navigate to="/schedules" replace />;
  }

  return <Outlet />;
}
